export const json = {
  completedHtml: 'Благодарим за сотрудничество!',
  pages: [
    {
      elements: [
        {
          choices: [
            'профессиональный интерес',
            'высокий статус конкурса',
          ],
          name: '1_element',
          hasOther: true,
          title:
            'Что повлияло на Ваше решение участвовать в работе жюри Всероссийского конкурса «Учитель года России» 2020 года?',
          type: 'checkbox',
        },
        {
          choices: [
            'конкурс существенно влияет на повышение престижа профессии учителя',
            'конкурс влияет на повышение престижа учителей-участников конкурса',
            'конкурс не влияет на повышение престижа профессии учителя'
          ],
          name: '2_element',
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» влияет на повышение престижа профессии учителя? ',
          type: 'checkbox',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '3_element',
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» можно рассматривать как способ популяризации профессии учителя?',
          type: 'radiogroup',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '4_element',
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» можно рассматривать как механизм выявления и распространения лучших педагогических практик?',
          type: 'radiogroup',
        },
        {
          choices: [
            'работа в настоящее время в образовательной организации (любого уровня)',
            'наличие ученой степени',
            'наличие почётных званий',
            'победа (победитель, призёр, лауреат) в конкурсе «Учитель года России» разных лет',
            'наличие опыта экспертной оценки в определенной предметной области'
          ],
          name: '5_element',
          title:
            'Отметьте позиции, которые, на Ваш взгляд, являются наиболее значимыми основаниями для включения экспертов в состав жюри первого очного тура Конкурса:',
          type: 'checkbox',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '6_1',
              title: 'оптимально',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '6_2',
              title: 'соответствует специфике деятельности учителя',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '6_3',
              title: 'позволяет объективнее оценить выступления конкурсантов',
              type: 'radiogroup',
            },
          ],
          name: '6_element',
          showNumber: true,
          title:
            'Считаете ли Вы, что формирование групп экспертов жюри первого очного тура на межпредметной основе',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_1',
              title: ' ',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '7_2',
              title: 'Предложите оптимальную, на Ваш взгляд, продолжительность:',
              type: 'text',
            },
          ],
          name: '7_element',
          showNumber: true,
          title:
            'Считаете ли Вы оптимальным и достаточным время (15 минут), отведенное на выступление конкурсанта в рамках конкурсного испытания «Методическая мастерская»?',
          type: 'panel',
        },
        {
          choices: [
            {
              value: 'sufficient',
              text: 'достаточна',
            },
            {
              value: 'insufficient',
              text: 'недостаточна',
            },
            {
              value: 'redundant',
              text: 'избыточна',
            },
          ],
          name: '8_element',
          title:
            'На Ваш взгляд, оценка 30 баллов за конкурсное испытание «Методическая мастерская»:',
          type: 'radiogroup',
        },
        {
          choices: [
            'сформулированы четко и понятно',
            'сформулированы недостаточно четко и понятно',
            'достаточны для оценки конкурсного испытания',
            'недостаточны для оценки конкурсного испытания',
            'соответствуют специфике конкурсного испытания',
            'не в полной мере соответствуют специфике конкурсного испытания'
          ],
          name: '9_element',
          hasOther: true,
          title:
            'Оцените формулировки критериев и показателей конкурсного испытания «Методическая мастерская»:',
          type: 'checkbox',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '10_1',
              title: ' ',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '10_2',
              title: 'Предложите оптимальную, на Ваш взгляд, продолжительность:',
              type: 'text',
            },
          ],
          name: '10_element',
          showNumber: true,
          title:
            'Считаете ли Вы, что в рамках конкурсного испытания «Урок» продолжительность работы педагога с детьми (35 минут) достаточна и оптимальна?',
          type: 'panel',
        },
        {
          choices: [
            {
              value: 'sufficient',
              text: 'достаточна',
            },
            {
              value: 'insufficient',
              text: 'недостаточна',
            },
            {
              value: 'redundant',
              text: 'избыточна',
            },
          ],
          name: '11_element',
          title:
            'На Ваш взгляд, оценка 60 баллов за конкурсное испытание «Урок»:',
          type: 'radiogroup',
        },
        {
          choices: [
            'сформулированы четко и понятно',
            'сформулированы недостаточно четко и понятно',
            'достаточны для оценки конкурсного испытания',
            'недостаточны для оценки конкурсного испытания',
            'соответствуют специфике конкурсного испытания',
            'не в полной мере соответствуют специфике конкурсного испытания'
          ],
          name: '12_element',
          hasOther: true,
          title:
            'Оцените формулировки критериев и показателей конкурсного испытания «Урок»:',
          type: 'checkbox',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '13_1',
              title: 'достаточна',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '13_2',
              title: 'объективна',
              type: 'radiogroup',
            },
          ],
          name: '13_element',
          showNumber: true,
          title:
            'Насколько, по Вашему мнению, используемая шкала оценивания конкурсных испытаний (0-1-2 балла):',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '14_1',
              title: 'достаточна:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '14_2',
              title: 'оптимальна:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '14_3',
              title: 'объективна:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '14_4',
              title: 'ориентирована на оценку практической деятельности учителя:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '14_5',
              title: 'отражает современные подходы к оценке деятельности учителя:',
              type: 'radiogroup',
            },
          ],
          name: '14_element',
          showNumber: true,
          title:
            'Насколько, по Вашему мнению, система критериев и показателей оценивания конкурсных испытаний первого очного тура заключительного этапа Конкурса-2020:',
          type: 'panel',
        },
        {
          name: '15_element',
          title:
            'Предложите необходимые, на Ваш взгляд, критерии оценки конкурсного испытания «Методическая мастерская»:',
          type: 'comment',
        },
        {
          name: '16_element',
          title: 'Предложите необходимые, на Ваш взгляд, критерии оценки конкурсного испытания «Урок»:',
          type: 'comment',
        },
        {
          name: '17_element',
          title: 'Назовите конкурсное испытание (испытания), которое, по Вашему мнению, следует включить в первый тур финала Конкурса-2021:',
          type: 'comment',
        },
        {
          name: '18_element',
          title: 'Перечислите затруднения, с которыми Вам, как члену жюри, пришлось столкнуться при оценивании испытаний первого тура Конкурса:',
          type: 'comment',
        },
        {
          name: '19_element',
          title: 'Ваши предложения по совершенствованию организации и проведения первого тура финала Конкурса:',
          type: 'comment',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '20_1',
              title: 'достаточна:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '20_2',
              title: 'условия работы жюри:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '20_3',
              title: 'мероприятия по программе:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '20_4',
              title: 'информационное сопровождение',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '20_5',
              title: 'трансфер:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '20_6',
              title: 'проживание:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '20_7',
              title: 'питание:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '20_8',
              title: 'организация конкурсных испытаний:',
              type: 'radiogroup',
            },
          ],
          name: '20_element',
          showNumber: true,
          title:
            'Оцените уровень организации Вашего пребывания на заключительном этапе Конкурса-2020:',
          type: 'panel',
        },
      ],
      name: 'page1',
      showNumber: false,
      showQuestionNumbers: 'true',
      title:
        'Уважаемый эксперт! Просим заполнить анкету, которая позволит учесть Ваше мнение при совершенствовании содержания, структуры и организации Всероссийского конкурса «Учитель года России» в 2021 году.',
    },
  ],
  showCompletedPage: true,
  title: 'АНКЕТА ЭКСПЕРТА ПЕРВОГО ТУРА финала Всероссийского конкурса «Учитель года России» 2020 года'
};
